const FormRow = ({ children, className = "", ...props }) => {
  return (
    <div className={`form-row ${className}`} {...props}>
      {children}
    </div>
  );
};

export default FormRow;
